module.exports = __webpack_public_path__ + "img/peacekeeper-elite.46bf78d3.png";